<template>
    <div 
      class="custom-input-wrapper"
      :style="wrapperStyle"
    >
      <el-input
        v-bind="$attrs"
        v-on="$listeners"
        :style="inputStyle"
      >
        <template v-for="(_, slot) in $slots" v-slot:[slot]>
          <slot :name="slot" />
        </template>
      </el-input>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CustomInput',
    inheritAttrs: false,
    props: {
      // 尺寸相关属性
      width: {
        type: String,
        default: ''
      },
      height: {
        type: String,
        default: ''
      },
      // 样式相关属性
      borderRadius: {
        type: String,
        default: '4px'
      },
      highlightColor: {
        type: String,
        default: '#409EFF'
      }
    },
    computed: {
      wrapperStyle() {
        return {
          '--border-radius': this.borderRadius,
          '--highlight-color': this.highlightColor,
          width: this.width || '100%',
          height: this.height
        }
      },
      inputStyle() {
        return {
          width: '100%',
          height: '100%'
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .custom-input-wrapper {
    position: relative;
    display: inline-flex;
  
    ::v-deep .el-input__inner {
      // 尺寸控制
      width: 100%;
      height: 100%;
      
      // 边框样式
      border-radius: var(--border-radius);
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      border: 1px solid #F4F4F4;
  
      // 交互状态
      &:hover {
        border-color: var(--highlight-color);
      }
      
      &:focus {
        border-color: var(--highlight-color);
        box-shadow: 0 0 0 2px rgba(var(--highlight-color), 0.2);
      }
  
      // 禁用状态
      &[disabled] {
        border-color: #EBEEF5;
        background-color: #f5f7fa;
      }
    }
  }
  </style>
  